import { createAction } from '@reduxjs/toolkit';

import type { MaterialType, MaterialsType, NoteType } from 'app/entities';
import type { PropsType, PlusStore, OpenType, ResultManyType, ResultOneType, ResultErrorType } from './types';

export const close = createAction('plus/close');

export const open = createAction('plus/open', (payload?: PropsType & OpenType) => ({
  payload,
}));

export const setProps = createAction('plus/setProps', (props?: PropsType) => ({
  payload: {
    props,
  },
}));

export const setUploadingInfo = createAction('plus/setUploadPercent', (data: { count?: number; percent?: number }) => ({
  payload: {
    data,
  },
}));

export const setDestination = createAction('plus/setDestination', (payload: { spaceId: number; folderId?: string }) => ({
  payload,
}));

export const parseText = createAction('plus/parseText', (payload: { value: string; privacy: boolean; spaceId?: number; folderId?: string }) => ({
  payload,
}));

export const parseFiles = createAction('plus/parseFile', (payload: { files: File[]; privacy: boolean; spaceId?: number; folderId?: string }) => ({
  payload,
}));

export const setMaterialResult = createAction('plus/setMaterialResult', (payload: ResultOneType) => ({
  payload,
}));

export const setMaterialsResult = createAction('plus/setMaterialsResult', (payload: ResultManyType) => ({
  payload,
}));

export const setErrorResult = createAction('plus/setErrorResult', (payload: ResultErrorType) => ({
  payload,
}));

export const parseDone = createAction('plus/parseDone');

export const setSummary = createAction('plus/setSummary', (value: string) => ({
  payload: {
    value,
  },
}));

export const addMaterialsToCollection = createAction('plus/addMaterialsToCollection', (collectionId: number, uploadSessionId) => ({
  payload: {
    collectionId,
    uploadSessionId,
  },
}));

export const addMaterialsToCollectionDone = createAction('plus/addMaterialsToCollectionDone');

export const openYoutubeActivation = createAction(
  'plus/openYoutubeActivation',
  (payload: { deviceCode: string; interval: number; userCode: string; verificationUrl: string }) => ({
    payload,
  }),
);

export const setYoutubeProcessingState = createAction(
  'plus/setYoutubeProcessingState',
  (payload: { value: PlusStore['youtubeProcessingState'] }) => ({
    payload,
  }),
);
